import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ArkikProductsActions from './arkik-products.actions';
import { ArkikProductsService } from './arkik-products.service';
import { ArkikAlertService } from 'src/app/shared/components/arkik-alert/arkik-alert.service';
import { TranslationService } from 'src/app/core/services/common/translation.service';
import { map, switchMap, catchError, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectArkikProducts } from './arkik-products.selectors';

@Injectable()
export class ArkikProductsEffects {
  constructor(
    private actions$: Actions,
    private arkikProductsService: ArkikProductsService,
    private alert: ArkikAlertService,
    private translation: TranslationService,
    private store: Store,
  ) {}

  loadArkikProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ArkikProductsActions.loadArkikProducts),
      switchMap(() =>
        this.store.select(selectArkikProducts).pipe(
          take(1),
          switchMap((products) => {
            if (products) {
              return of(ArkikProductsActions.loadArkikProductsSuccess({ products }));
            }
            return this.arkikProductsService.getArkikProducts().pipe(
              map((response) => ArkikProductsActions.loadArkikProductsSuccess({ products: response })),
              catchError((e) => {
                this.alert.error(e?.error?.message || this.translation.pt('views.globals.an-error-occurred'));
                return of(
                  ArkikProductsActions.loadArkikProductsFailure({
                    error: e?.error?.message || this.translation.pt('views.globals.an-error-occurred'),
                  }),
                );
              }),
            );
          }),
        ),
      ),
    ),
  );

  refreshArkikProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ArkikProductsActions.refreshArkikProducts),
      map(() => ArkikProductsActions.resetArkikProducts()),
    ),
  );
}
